import React from 'react';
import { connect } from 'react-redux';
import { getScreenData, setScreenData, getScreenKey, fieldEditUpdate } from 'cw-ui-core';
import _ from 'lodash';
import InputField from './InputField';

const mapStateToProps = (state, props) => {
    const screenKey = getScreenKey(props.screenKey);
    const widget = React.Children.only(props.children);
    const childrenValue = widget?.props?.value;
    return {
        automationName: widget.props.automationName ? widget.props.automationName : _.last(props?.path),
        value: childrenValue || getScreenData(state.screen, props.path, screenKey),
        screenKey,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const screenKey = getScreenKey(props.screenKey);

    return {
        onChange: newValue => {
            dispatch(setScreenData(props.path, newValue, screenKey));
            dispatch(fieldEditUpdate(props.path, newValue, screenKey));
        },
        setFieldValidity: isValid => {
            const fieldName = _.last(props?.path);
            if (fieldName) dispatch(setScreenData(['fieldsValidity', fieldName], isValid, screenKey));
        },
    };
};

const InputFieldContainer = connect(mapStateToProps, mapDispatchToProps)(InputField);

export default InputFieldContainer;
